export const titleCase = (str: string) => {
  if (!str) return ''
  const res = str
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .trim()
  return res.charAt(0).toUpperCase() + res.slice(1)
}

if (import.meta.vitest) {
  const { expect, it } = import.meta.vitest

  it.each([
    { expected: 'This is great', input: 'thisIsGreat' },
    { expected: 'This is awesome', input: 'thisIsAwesome' },
    { expected: '', input: '' },
  ])('titleCase($input) -> $expected', ({ expected, input }) => {
    expect(titleCase(input)).toBe(expected)
  })
}
